import React, { createContext, useState } from 'react';

const AircraftContext = createContext(null);

function AircraftContextProvider(props) {
  const [aircraft, setAircraft] = useState(null);

  return (
    <AircraftContext.Provider
      value={{
        aircraft: aircraft || JSON.parse(localStorage.getItem('current_aircraft')),
        setAircraft: setAircraft,
      }}
    >
      {props.children}
    </AircraftContext.Provider>
  );
}

export { AircraftContextProvider, AircraftContext as aircraftContext };
